import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Checkbox } from 'antd';
import { parseBoolOr } from '../../App/AppxUtils';


function InputCheckboxGroup(props) {
    const { t } = useTranslation('appxweb');
    const required = parseBoolOr(props.required, false);
    let rules = [];

    if (required) {
        let rule = {
            required: true,
        }

        if (props.label != null) {
            rule.message = t('AppxForm.input_required', {field: props.label});
        }

        rules.push(rule);
    }

    if (Array.isArray(props.rules) && props.rules.length > 0) {
        rules = [...rules, ...props.rules];
    }

    return (
        <Form.Item
            className={props.className}
            name={props.name}
            label={props.hideLabel !== true ? props.label : null}
            rules={rules}
            help={props.help}
            style={props.style}
        >
            <Checkbox.Group
                options={props.options}
                defaultValue={props.defaultValue}
                onChange={props.onChange}
                style={props.checkboxStyle}
                disabled={props.disabled}
            >
                {props.children}
            </Checkbox.Group>
        </Form.Item>
    );
}

export default InputCheckboxGroup;
